import { render } from "./OperationsPricing.vue?vue&type=template&id=32408496&scoped=true"
import script from "./OperationsPricing.vue?vue&type=script&lang=js"
export * from "./OperationsPricing.vue?vue&type=script&lang=js"

import "./OperationsPricing.vue?vue&type=style&index=0&id=32408496&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32408496"]])

export default __exports__